<template>
  <section>
    <v-data-iterator
      :items="sortedAchievements"
      no-data-text="Add your first achievement"
      content-tag="v-layout"
      hide-actions
      wrap
      row
    >
      <template slot="item" slot-scope="{ item: achievement }">
        <v-flex xs12 md6 class="pa-2" :key="`achievement-${achievement.title}`">
          <Achievement :achievement="achievement" @refresh="refresh" />
        </v-flex>
      </template>
    </v-data-iterator>
    <div v-if="adding" class="pa-2">
      <Achievement :achievement="adding" @refresh="refresh" />
    </div>
    <div v-else class="text-xs-center py-4">
      <v-chip slot="activator">
        <v-avatar>
          <v-btn
            slot="activator"
            :color="themes.candidate.light.secondaryActionButton"
            @click="createAchievement"
            small
            fab
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-avatar>
        Add achievement
      </v-chip>
    </div>
  </section>
</template>

<script>
// Components
import Achievement from '@/components/candidate/profile/edit/details/Achievement'

// Vue Component
export default {
  components: { Achievement },

  props: { value: { type: Array, default: () => [] } },

  data() {
    return {
      adding: null,
    }
  },

  computed: {
    sortedAchievements() {
      const achievements = JSON.parse(JSON.stringify(this.value))
      return achievements.sort(({ achievedAt: a }, { achievedAt: b }) => {
        if (!a) return -1
        if (!b) return 1
        if (new Date(a) > new Date(b)) return -1
        if (new Date(a) < new Date(b)) return 1
        return 0
      })
    },
  },
  methods: {
    createAchievement() {
      this.adding = {
        achievedAt: '',
        description: '',
        title: '',
      }
    },

    refresh() {
      this.adding = null
      this.$emit('refresh')
    },
  },
}
</script>
